
<div class="user-profile">
    <header class="profile-header">
      <button mat-icon-button class="back-button" (click)="goBack()">
        <mat-icon class="back-icon">arrow_back</mat-icon>
      </button>
      <div class="user-info">
        <div class="avatar" *ngIf="!userData.avatar">
          <span class="avatarlbl">{{userData.firstname?.charAt(0)}}{{userData.lastname?.charAt(0)}}</span>
        </div>
        <img *ngIf="userData.avatar" [src]="userData.avatar" class="avatar" alt="User Avatar">
        <h1 class="user-name">{{userData.firstname}} {{userData.lastname}}</h1>
      </div>
    </header>
  
    <main class="profile-content">
      <section class="spec-section">
        <div class="profile-items">
          <!-- Personal Information -->
          <div [ngClass]="{'highlight': selectedItem === 'name'}" class="profile-item">
            <div class="highlight-inner">
              <div class="item" (click)="onItemSelect('name')">
                <span class="item-label">Name</span>
                <span class="item-value">{{userData.firstname}} {{userData.lastname}}</span>
              </div>
              <app-useritem *ngIf="selectedItem === 'name'" name="Name" type="multiinputs" 
                [userData]="userNamesData" (action)="onAction($event)">
              </app-useritem>
            </div>
          </div>
  
          <div [ngClass]="{'highlight': selectedItem === 'email'}" class="profile-item">
            <div class="highlight-inner">
              <div class="item" (click)="onItemSelect('email')">
                <span class="item-label">Email Address</span>
                <span class="item-value">{{userData.email}}</span>
              </div>
              <app-useritem *ngIf="selectedItem === 'email'" name="Email Address" 
                [itemValue]="userData.email" (action)="onAction($event)">
              </app-useritem>
            </div>
          </div>
  
          <div [ngClass]="{'highlight': selectedItem === 'address'}" class="profile-item">
            <div class="highlight-inner">
              <div class="item" (click)="onItemSelect('address')">
                <span class="item-label">Address</span>
                <span class="item-value">
                  {{userData.aptsuite}}{{userData.aptsuite ? ', ' : ''}}
                  {{userData.address}}{{userData.address ? ', ' : ''}}
                  {{userData.city}}{{userData.city ? ', ' : ''}}
                  {{userData.state ? selectedState.stateName : ''}}{{userData.state ? ', ' : ''}}
                  {{userData.postalcode}}
                </span>
              </div>
              <app-useritem *ngIf="selectedItem === 'address'" name="Address" type="multiinputs" 
                [userData]="userAddressData" [selectData]="selectData" (action)="onAction($event)">
              </app-useritem>
            </div>
          </div>
  
          <div [ngClass]="{'highlight': selectedItem === 'gender'}" class="profile-item">
            <div class="highlight-inner">
              <div class="item" (click)="onItemSelect('gender')">
                <span class="item-label">Gender</span>
                <span class="item-value">{{userData.gender}}</span>
              </div>
              <app-useritem *ngIf="selectedItem === 'gender'" name="Gender" [itemValue]="userData.genderShort" 
                type="gender" [radioOptions]="genderOptions" (action)="onAction($event)">
              </app-useritem>
            </div>
          </div>
  
          <div [ngClass]="{'highlight': selectedItem === 'birthdate'}" class="profile-item">
            <div class="highlight-inner">
              <div class="item" (click)="onItemSelect('birthdate')">
                <span class="item-label">Birth Date</span>
                <span class="item-value">{{userData.birthdate}}</span>
              </div>
              <app-useritem *ngIf="selectedItem === 'birthdate'" [disabled]="true" name="Birth Date" 
                type="date" [dateValue]="userData.birthdate" (action)="onAction($event)">
              </app-useritem>
            </div>
          </div>
  
          <div [ngClass]="{'highlight': selectedItem === 'mobilephone'}" class="profile-item">
            <div class="highlight-inner">
              <div class="item" (click)="onItemSelect('mobilephone')">
                <span class="item-label">Mobile Phone</span>
                <span class="item-value">{{userData.mobilephone}}</span>
              </div>
              <app-useritem *ngIf="selectedItem === 'mobilephone'" name="Mobile Phone" 
                [itemValue]="userData.mobilephone" (action)="onAction($event)">
              </app-useritem>
            </div>
          </div>
  
          <div [ngClass]="{'highlight': selectedItem === 'password'}" class="profile-item">
            <div class="highlight-inner">
              <div class="item" (click)="onItemSelect('password')">
                <span class="item-label">Password</span>
                <span class="item-value">••••••</span>
              </div>
              <app-useritem *ngIf="selectedItem === 'password'" inputType="password" name="Password" 
                [itemValue]="userData.password" (action)="onAction($event)">
              </app-useritem>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>